import React from "react";
import { Upload, message, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

export default function UploadFile({ form }) {
  const urlCode = useSelector(state => state.urlCode)
  const props = {
    name: "file",
    method: "POST",
    action: `${
      process.env.REACT_APP_API_ENDPOINT
    }/upload/bom?token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
    headers: {
      authorization: "authorization-text",
    },
    body: JSON.stringify({ title: 'React POST Request Example' }),
    beforeUpload: (file, fileList) => {
      
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  return (
    <Upload {...props} headers={{  typ: "Plan", subTyp: "" }}>
      <Button
        style={{ fontWeight: 600 }}
        type="primary"
        icon={<UploadOutlined />}
      >
        Upload File
      </Button>
    </Upload>
  );
}
